/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RuleMutingBulkDto = {
    mutedUntil?: number;
    mutingMode: RuleMutingBulkDto.mutingMode;
    ruleIds: Array<string>;
};

export namespace RuleMutingBulkDto {

    export enum mutingMode {
        INDEFINITE = 'INDEFINITE',
        UNTIL_DATE = 'UNTIL_DATE',
        UNTIL_NEXT_STATUS_IMPROVES = 'UNTIL_NEXT_STATUS_IMPROVES',
        NOT_MUTED = 'NOT_MUTED',
    }


}
